<template>
  <div class="dashboard__list__row">
    <div class="checkbox__cell row-cell">
      <slot name="checkbox"></slot>
    </div>
    <div class="unit__cell row-cell">
      <div class="signal signal--on"></div>
      <div class="name">
          <span v-if="tentacle.name">{{ nameFormatted }}</span>
          <span class="placeholder" v-else>-no name-</span>
        <div v-if="this.getTentacleCalibrationName(tentacle) && showInEnv([env_tentacles, env_flower])" class="batch">{{ $t('dashboard.nav.batch') }}: {{ this.getTentacleCalibrationName(tentacle) }}</div>
        <div v-if="tentacle.payload && tentacle.payload.name && showInEnv([env_tentacles, env_flower])" class="batch">{{ $t('detail.format') }}: {{ tentacle.payload.name }}</div>
      </div>
    </div>
<!--      <div class="order__cell row-cell" v-bind:class="{'order__cell&#45;&#45;selected': tentacle.favourite}" v-responsive.sm.md.xs>-->
<!--          <BaseIcon v-on:click="changeOrder" icon="star-full" />-->
<!--      </div>-->
    <div class="customer__cell header-cell" v-if="user.is_dealer">
      {{ tentacle.customer }}
    </div>
    <div class="remark__cell row-cell"  v-responsive.sm.md.xl.lg>
      <BaseInputCell
              :value="tentacle.remark ? tentacle.remark : ''"
              :tentacle="tentacle"
              @onChange="setRemark"
      />
    </div>
    <div class="dynamic-section" v-responsive.xl v-if="showInEnv([env_tentacles, env_flower])">
      <Sensor
        v-for="sensor in tentacle.sensors"
        :key="sensor.id"
        :sensor="sensor"
      />
    </div>
    <div class="last-update__cell row-cell" v-responsive.xl.lg.md>
      <div>
        <div class="time">{{ tentacle.lastUpdate !== null ? compLastTime : 'N/A' }}</div>
        <div class="date">{{ tentacle.lastUpdate !== null ? compLastDate : 'N/A' }}</div>
      </div>
    </div>
    <div class="event__cell row-cell" v-responsive.xl.lg.md v-if="showInEnv([env_tentacles, env_flower])">
        <div v-if="this.tentacle.lastEvent" v-tooltip.top="$t(this.lastEventMessage)">
          <span :class="'description ' + this.lastEventLevel">
              <font-awesome-icon icon="fa-solid fa-triangle-exclamation" />
          </span>
        </div>
      <div v-if="this.tentacle.lastEvent">
        <div class="time">{{ compEvtTime }}</div>
        <div class="date">{{ compEvtDate }}</div>
      </div>
    </div>
    <div class="lqi__cell row-cell"  v-responsive.sm.md.xl.lg v-if="showInEnv([env_tentacles, env_flower])">
      <div class="lqi">
        <svg v-if="tentacle.lqi" class="coverage-icon icon" width="24" height="24"><use :href="'/svg-sprite.svg#'+ this.lqiStrength"></use></svg>
      </div>
    </div>
    <div class="order__cell row-cell" v-bind:class="{'order__cell--selected': tentacle.favourite}" v-if="showInEnv([env_tentacles, env_flower]) && !user.is_dealer">
      <div v-on:click="changeOrder" style="margin: auto;" class="test-button-favourite">
        <BaseIcon icon="star-full" />
      </div>
    </div>
    <div class="action__cell row-cell">
      <router-link :to="{ name: 'detail', params: { id: tentacle.id }}" class="test-button-detail">
        <BaseButton v-responsive.sm.md.lg.xl>
            <span>{{ $t('buttons.detail') }}</span>
          <BaseIcon icon="chevron-right" />
        </BaseButton>
        <BaseIcon icon="chevron-right" v-responsive.xs  style="fill: #B2DE4D; width: 5rem;"/>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { dynamicTiming, dynamicSensing } from '@/config/tentacles.js';
import Sensor from '@/components/Sensor.vue';
import BaseIcon from '../../components/BaseIcon.vue';

export default {
  name: 'DashboardListRow',
  components: {
    BaseIcon,
    Sensor,
  },
  data() {
    return {
      showTimSen: false,
      SOIL_3XS: 1,
      env_emeta: process.env.VUE_APP_ENV_EMETA,
      env_tentacles: process.env.VUE_APP_ENV_TENTACLES,
      env_etentacles: process.env.VUE_APP_ENV_ETENTACLES,
      env_flower: process.env.VUE_APP_ENV_FLOWER,
    };
  },
  props: {
    tentacle: {
      type: Object,
      required: true,
    },
    sensors: {
      type: Array,
    },
  },
  computed: {
    ...mapGetters('tentacle', ['user', 'type', 'timeFormat', 'nameFormat']),
    compLastTime() {
      const newDate = new Date(Number(this.tentacle.lastUpdate) * 1000);
      let utcTime = this.getUtcDate(newDate);
      return this.moment(utcTime).format(this.timeFormat ? 'hh:mm a' : 'HH:mm');
    },
    compLastDate() {
      const newDate = new Date(Number(this.tentacle.lastUpdate) * 1000);
      let utcDate = this.getUtcDate(newDate);
      this.moment.locale(this.$i18n.locale.toLowerCase());
      return this.moment(utcDate).format('DD MMM YYYY');
    },
    compEvtTime() {
      let newDate = new Date(Number(this.tentacle.lastEvent['timestamp']) * 1000);
      return this.moment(newDate).format(this.timeFormat ? 'hh:mm a' : 'HH:mm');
    },
    nameFormatted() {
      return this.nameFormat ? this.tentacle.name : this.tentacle.genericName;
    },
    compEvtDate() {
      let newDate = new Date(Number(this.tentacle.lastEvent['timestamp']) * 1000);
      let utcDate = this.getUtcDate(newDate);
      this.moment.locale(this.$i18n.locale.toLowerCase());
      return this.moment(utcDate).format('DD MMM YYYY');
    },
    dynamicTiming() {
      for (let i = 0; i < dynamicTiming.length; i += 1) {
        dynamicTiming[i].name = this.$t(`timing.${dynamicTiming[i].label}`);
      }
      return dynamicTiming;
    },
    dynamicSensing() {
      for (let i = 0; i < dynamicSensing.length; i += 1) {
        dynamicSensing[i].name = this.$t(`sensing.${dynamicSensing[i].label}`);
      }
      return dynamicSensing;
    },
    lastEventLevel() {
      return this.tentacle.lastEvent['level'];
    },
    lastEventMessage() {
      let messageObject = JSON.parse(this.tentacle.lastEvent.message);
      switch (this.tentacle.lastEvent['name']) {
        case 'sequence':
          return this.$t('eventChart.' + this.tentacle.lastEvent['name'] + 'Message', {actual: messageObject['actual'], previous: messageObject['previous'] + 1});
        case 'lqi':
          return this.$t('eventChart.' + this.tentacle.lastEvent['name'] + 'Message', {lqi: messageObject['lqi'], badCount: messageObject['badCount']});
        case 'ack':
          let expectedAt = new Date(Number(messageObject['expectedAt']) * 1000);
          expectedAt.setHours(expectedAt.getHours() + 2);
          return this.$t('eventChart.' + this.tentacle.lastEvent['name'] + 'Message', {expectedAt: this.moment(expectedAt).format(this.timeFormat ? 'DD MMM YYYY, hh:mm a' : 'DD MMM YYYY, HH:mm')});
        default:
          return this.$t('eventChart.' + this.tentacle.lastEvent['name'] + 'Message');
      }
    },
    lqiStrength() {
      let options = {'Excellent': 'coverage-best', 'Good': 'coverage-good', 'Average': 'coverage-average', 'Limit': 'coverage-working'}
      return options[this.tentacle.lqi];
    }
  },
  methods: {
    updateTentacles(data) {
      this.$store.dispatch('tentacle/updateUnit', data).then((response) => {
        if (response.status === 200) {
          this.flash('Tentacles updated', 'success');
          let customer = this.$store.getters['customer/customer'];
          let type = this.$store.getters['tentacle/type'];
          let tentacle = this.$store.getters['tentacle/unitById'](this.tentacle.id);
          let params = {customer: customer, type: type};
          this.$store.dispatch('tentacle/setType', params);
        }
      });
    },
    // try to check this
    getTimmingOption(value) {
      // return this.dynamicTiming.find(item => item.value === value);
      return this.dynamicTiming.find(item => item.value === value);
    },
    getSensingOption(value) {
      return dynamicSensing.find(item => item.value === value);
    },
    setDynamicTiming(option) {
      this.updateTentacles([{ id: this.tentacle.id, measurementInterval: option.value }]);
    },
    setDynamicSensing(option) {
      this.updateTentacles([{ id: this.tentacle.id, dynamicSensing: option.value }]);
    },
    setRemark(remark) {
      this.updateTentacles([{ id: this.tentacle.id, remark }]);
    },
    getUtcDate(date){
      return new Date(date.getUTCFullYear(),date.getUTCMonth(),date.getUTCDate(),date.getUTCHours(),date.getUTCMinutes(),date.getUTCSeconds());
    },
    changeOrder() {
      this.updateTentacles([{ id: this.tentacle.id, favourite: (!this.tentacle.favourite ? 1 : 0) }]);
    },
    getTentacleCalibrationName(tentacle) {
      if (!tentacle.batch){
        return null;
      }

      let calibrationName = tentacle.batch.name;

      if (Object.keys(tentacle.properties).length > 0) {
        let properties = Object.values(tentacle.properties);
        calibrationName = properties.join('-');
      }

      return calibrationName;
    },
    showInEnv(type) {
      if (Array.isArray(type)) {
        return type.includes(process.env.VUE_APP_ENVIRONMENT);
      }
      return process.env.VUE_APP_ENVIRONMENT === type;
    },
  },
};
</script>

<style lang="scss" scoped>
.dashboard__list__row {
  width: 100%;
  min-height: 6rem;
  display: flex;
  align-items: stretch;
  border-bottom: 0.1rem solid $border-color;
}
.row-cell {
  display: flex;
  align-items: center;
}

.checkbox__cell {
  width: 5rem;
  justify-content: center;
}

.dynamic-section {
  margin-left: 10px;
  flex-grow: 1;
  display: flex;
  align-items: stretch;
}
.action__cell {
    width: max-content;
    margin-left: auto;
    padding: 1em;

    a {
        text-decoration: none;
    }
}
.unit__cell {
  width: 23rem;
  margin-top: 0.4em;
  margin-bottom: 0.4em;
  .signal {
    width: 0.8rem;
    height: 0.8rem;
    border-radius: 50%;
    margin-right: 0.8rem;
    padding-right: 0.8em;

    &--on {
      background-color: $company-color;
    }

    &--off {
      background-color: $danger;
    }
  }
  .name {
    font-weight: 600;
    color: $dark;
    font-size: 1.3rem;
    width: 100%;
    word-wrap: break-word;
    padding-right: 1.2em;

    .batch {
      margin-top: 2px;
      font-size: 1rem;
      color: $grey;
      font-weight: 400;
    }
    .placeholder {
      color:rgba(172,180,197,0.35);
    }
  }
}

.remark__cell {
  width: 16rem;
  font-size: 1.3rem;
  font-weight: 500;
  color: $grey;

  .icon {
    margin-left: 10px;
    cursor: pointer;
    fill: $grey;
    width: 1.2rem;
    height: 1.2rem;
    transition: all 0.4s;

    &:hover {
      fill: $company-color;
    }
  }
}

.lqi__cell {
  width: 5rem;
  font-size: 1.3rem;
  font-weight: 500;
  color: $grey;

  .icon {
    margin-left: 10px;
    width: 2.5rem;
    height: 2.5rem;
    transition: all 0.4s;

    &:hover {
      fill: $company-color;
    }
  }
}

.customer__cell {
  width: 13rem;
  font-size: 1.3rem;
  font-weight: 500;
  color: $grey;
  padding-right: 2rem;
  display: flex;
  align-items: center;

  .icon {
    margin-left: 10px;
    width: 2.5rem;
    height: 2.5rem;
    transition: all 0.4s;

    &:hover {
      fill: $company-color;
    }
  }
}

.last-update__cell {
  width: 12rem;
  margin-left: auto;

  .time {
    font-size: 1.3rem;
    font-weight: 500;
  }

  .date {
    color: $grey;
  }
}

.event__cell {
  width: 12rem;
  margin-left: auto;

  .time {
    font-size: 1.3rem;
    font-weight: 500;
  }

  .date {
    color: $grey;
  }

  .warning {
    color: #f98e00;
  }

  .info {
    color: #59bbff;
  }

  .error {
    color: #cd0300;
  }

  .description {
    font-size: 2rem;
    width: 2rem;
    display: inline-flex;
    align-items: center;
    height: 3rem;
    text-align: end;
    margin-right: 2rem;
    position: relative;

    &:after {
      content: '';
      display: inline-block;
      position: absolute;
      right: -1rem;
      width: 0.2rem;
      height: 100%;
      background-color: $very-light-grey;
    }
  }
}

.dynamic-timing__cell {
  width: 18rem;
  margin-left: auto;
}

.dynamic-sensing__cell {
  width: 20rem;
  margin-left: auto;
}

.order__cell {
  width: 7rem;
  margin-left: 0.5rem;
    fill: #c3c3c3;
    &:hover {
        fill: gold;
    }
    &--selected {
        fill: gold;
    }
    svg{
        cursor: pointer;
    }
    @media only screen and (max-width: 991px) {
        width: 9rem;
        svg {
            margin:auto;
        }
    }
}

.help__paragraph {
  color: $white;
}
</style>
